import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0px -20px",
    fontSize: theme.typography.pxToRem(11),
    "& .MuiButton-root": {
      padding: 0,
      color: "#F15A28",
      fontSize: theme.typography.pxToRem(16),
      fontFamily: "Lato",
      fontWeight: 600,
      "& .MuiButton-startIcon": {
        margin: "0",
        paddingLeft: "4px",
        width: "29px",
      },
      "& .MuiButton-endIcon": {
        marginLeft: "17px",
        width: "25px",
        padding: 0,
      },
    },
    "& .MuiGrid-item:nth-child(1)": {
      "& .MuiTypography-root": {
        marginLeft: "29px",
      },
    },
    "& .MuiGrid-item:nth-child(2)": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      "& .MuiTypography-root": {
        marginRight: "40px",
      },
    },
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 500,
      marginTop: "5px",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    "& .MuiDivider-root:nth-child(1)": {
      margin: "50px 0 30px 0",
    },
    "& .MuiDivider-root:nth-child(3)": {
      margin: "30px 0 50px 0",
    },
  },
  buttonIcon: {
    fontSize: `${theme.typography.pxToRem(15)} !important`,
  },
}));
